import { Table, Tabs, Button, Pagination, Image, Tooltip, Modal, Form, Radio, message, Spin, Tag } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss'
import { useEffect } from 'react';
import UploadImg from './UploadImg';
import { assignFileList, fileUpload, batchDeleteResource } from "@/apis/public"

const MaterialManagement = () => {
	const [loading, setLoading] = useState(false)
	const [form] = Form.useForm()
	const [params, setParams] = useState({
		type: "News",
	})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [total, setTotal] = useState(1000)
	const [data, setData] = useState([])
	const [isShowModal, setIsShowModal] = useState(false)
	const [fileList, setFileList] = useState([])

	useEffect(() => {
		if (fileList.length > 0) {
			form.setFieldValue('imgFile', "file")
			form.validateFields(['imgFile'])
		} else {
			form.setFieldValue('imgFile', "")
		}
	}, [fileList])

	const columns = [
		{
			title: "文件名称",
			key: 'fileName',
			dataIndex: 'fileName',
		}, {
			title: "是否关联",
			key: 'associationStatus',
			dataIndex: 'associationStatus',
			render: (text, record) => {
				return <Tag color={record.associationStatus === 1 ? "green" : "magenta"}>{record.associationStatus === 1 ? "是" : "否"}</Tag>
			},
		}, {
			title: "上传时间",
			key: 'time',
			dataIndex: 'updateTime',
		}, {
			title: "文件id",
			key: 'fileuuid',
			dataIndex: 'fileUuid',
			render: (text, record) => {
				return <Tooltip title="点击复制">
					<div className={styles.copyBox} onClick={() => { copyText(record.fileUuid) }}>{record.fileUuid}</div>
				</Tooltip>
			},
		}, {
			title: "预览",
			key: 'filePath',
			render: (text, record) => {
				return <Image
					width={55}
					src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + record.filePath}
				/>
			},
		}, {
			title: "操作",
			key: 'opreation',
			render: (text, record) => {
				return <div className={styles.btnBox}>
					{record.associationStatus !== 1 && <Button type="primary" onClick={() => deleteImg(record.fileUuid)} size="small">删除</Button>}
				</div>
			},
		},
	];
	const items = [
		{
			key: "News",
			label: '新闻',
			children: '',
		}, {
			key: "Blog",
			label: '博客',
			children: '',
		}, {
			key: "Events",
			label: '事件',
			children: '',
		}
	];

	const getList = () => {
		assignFileList({
			pageParam: pageParam,
			...params
		}).then(res => {
			setTotal(res.data.total)
			setData(res.data.records)
		}).catch(err => { })
	}
	// const handleKeyDown = (e) => {
	// 	if (e.keyCode === 13) {
	// 		getList()
	// 	}
	// }

	// 删除文件
	const deleteImg = (id) => {
		batchDeleteResource({
			fileUuids: [id]
		}).then(res => {
			message.success("删除成功")
			setPageParam({ ...pageParam, currentPage: 1 })
		}).catch(res => {
		})
	}

	useEffect(() => {
		getList()
	}, [params, pageParam])
	const addNews = () => {
		setIsShowModal(true)
		form.setFieldValue('materialType', "News")
	}

	const onFinish = (values) => {
		setLoading(true)
		const formData = new FormData()
		formData.append("multipartFiles", fileList[0].xhr)
		formData.append("secondType", values.materialType)
		fileUpload(formData).then(res => {
			setLoading(false)
			message.success("上传成功")
			setFileList([])
			setIsShowModal(false)
			setPageParam({ ...pageParam, currentPage: 1 })
		}).catch(err => {
			setLoading(false)
		})
	}

	const copyText = (text) => {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(text)
		} else {
			const textArea = document.createElement("textarea");
			textArea.value = text;
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			document.execCommand("Copy");
			document.body.removeChild(textArea);
		}
		message.success("复制成功")
	}

	const operations = <Button onClick={addNews} type="primary">上传素材</Button>;

	return <Spin spinning={loading}>
		<div className={classNames('container', styles.materialBox)}>
			<h3>素材管理</h3>
			<Tabs
				tabBarExtraContent={operations}
				type="card"
				defaultActiveKey={params.type}
				items={items}
				onChange={(e) => {
					setParams({ ...params, type: e })
					setPageParam({ ...pageParam, currentPage: 1 })
				}} />
			{/*<Space.Compact className={styles.paramsBox}>
			<Input
				allowClear
				placeholder="文件名称"
				onKeyDown={handleKeyDown}
				onChange={(e) => {
					setParams({ keywords: e.target.value })
				}} />
			<Button type="primary" onClick={getList}>搜索</Button>
		</Space.Compact>*/}
			<Table rowKey={record => record.fileUuid} pagination={false} columns={columns} dataSource={data} />
			<Pagination
				align="end"
				style={{ marginTop: "20px" }}
				current={params.currentPage}
				pageSize={params.pageSize}
				total={total}
				showSizeChanger={false}
				showQuickJumper
				onChange={(page, pageSize) => {
					setPageParam({
						currentPage: page,
						pageSize: pageSize,
					});
				}}
			/>
			<Modal
				title="素材上传"
				width={400}
				open={isShowModal}
				maskClosable={false}
				footer={null}
				onCancel={() => {
					setIsShowModal(false)
					setFileList([])
				}}>
				<Form
					onFinish={onFinish}
					autoComplete="off"
					form={form}
					className={styles.modalFormBox}
				>
					<Form.Item
						label="类型"
						name="materialType"
						rules={[
							{
								required: true,
								message: "请选择类型"
							},
						]}
					>
						<Radio.Group
							options={[
								{ value: "News", label: "新闻" },
								{ value: "Blog", label: "博客" },
								{ value: "Events", label: "事件" },
							]}
						/>
					</Form.Item>

					<Form.Item
						label="素材图片"
						name="imgFile"
						rules={[
							{
								required: true,
								message: "请上传图片",
							},
						]}
					>
						<UploadImg fileList={fileList} setFileList={setFileList} />
					</Form.Item>

					<Form.Item style={{ "marginTop": "40px" }}>
						<Button type="primary" htmlType="submit">
							上传
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	</Spin>
}
export default MaterialManagement;